t = require('views/internal/teacup-with-helpers')('invite_add_name')

module.exports = t.renderable ({ email, fullName, canAddAsObserver, modelType }) ->
  t.p '.quiet', ->
    if modelType == 'Board'
      t.format 'click-send-below'
    else if modelType == 'Organization'
      t.format 'we dont know that person…team', { email }
    else
      throw new Error("Expected either Board or Organization as modelType; got #{ modelType }")

  t.p '.error.hide.js-name-error', ->
    t.format 'full name too short'

  t.p '.error.hide.js-name-error-url', ->
    t.format 'full name must not contain a url'

  t.form '.js-email-data', ->

    t.label ->
      t.format 'full-name'
    t.input '.js-autofocus.js-full-name', { type: 'text', value: fullName }

    t.input '.js-email', { type: 'hidden', value: email }

    if canAddAsObserver
      t.span '.check-div.quiet.u-clearfix', { style: t.stylify('margin-left': '24px', 'padding-top': '2px', 'font-size': '12px', 'line-height': '15px') }, ->
        t.input { type: 'checkbox', id: 'addAsObserver' }
        t.label { for: 'addAsObserver' }, ->
          t.format 'include-this-member-as-a-view-only-observer'

    t.input '.wide.primary.js-send-email-invite', { type: 'submit', value: t.l('send') }




// WEBPACK FOOTER //
// ./app/scripts/views/templates/invite_add_name.coffee